/* Homepage consultation actions. Instagram thumbnails are initial HTML images. */
(function () {
  'use strict';
  if (window.pinoHomeMediaInit) return;
  window.pinoHomeMediaInit = true;
  function init(scope) {
    scope.querySelectorAll('[data-pk-support-chat]').forEach(function (button) {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', function () {
        var launcher = document.getElementById('pino-concierge')?.shadowRoot?.querySelector('.launcher');
        var status = button.closest('.pk-consult-card').querySelector('[data-pk-support-chat-status]');
        if (launcher) {
          if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
          status.textContent = '';
        } else {
          status.textContent = 'チャットを読み込めませんでした。ページを再読み込みするか、LINEでご相談ください。';
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
